import { Controller } from "@hotwired/stimulus"

// Toggles the Number field-properties form based on the selected number type:
// the currency picker is only relevant for Currency, Min/Max only for plain Number.
export default class extends Controller {
  static targets = ["type", "currency", "minMax"]

  connect() {
    this.change()
  }

  change() {
    const type = this.typeTarget.value

    if (this.hasCurrencyTarget) {
      this.currencyTarget.style.display = type === "currency" ? "" : "none"
    }

    if (this.hasMinMaxTarget) {
      this.minMaxTarget.style.display = type === "number" ? "" : "none"
    }
  }
}
